import apiPath from '@store/apiPath'

export default {
  /**
   * 자동 완성
   * @method GET
   */
  FETCH_AUTO_COMPLETE: `${apiPath.OPENSEARCH}/v1/autocomplete`,
}
